import { concat } from '@ember/helper';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}

const NonSmallCellCancerTypes = [
  'adenocarcinoma',
  'squamous-cell-carcinoma',
  'large-cell-carcinoma'
];

const mutations = [
  'brca1',
  'brca2',
  'alk',
  'ros1',
  'egfr',
  'met',
  'her2',
  'braf',
  'kras',
  'stk11'
];

export default class MedicalHistoryFormLungCancerPathologyComponent extends Component<Signature> {
  get mutations(): string[] {
    return mutations;
  }

  get nonSmallCellCancerTypes(): string[] {
    return NonSmallCellCancerTypes;
  }

  <template>
    {{!     Cell cancer type     }}
    <div class='field'>
      <@form.ConditionalRadioGroup
        @propertyName='cellCancerType'
        @conditionalValue='non-small-cell-cancer'
        as |ConditionalRadioGroup showConditionalBlock|
      >
        <div class='field'>
          <ConditionalRadioGroup.AlignedFieldsRadioGroup
            @title='Type de cancer'
            as |Group|
          >
            <Group.FieldRadio
              @label='Cancer non à petite cellule (CNPC)'
              @value='non-small-cell-cancer'
            />
            <Group.FieldRadio
              @label='Cancer à petite cellule (CPC)'
              @value='small-cell-cancer'
            />
            <Group.FieldRadio @label='Mésothéliome' @value='mesothelioma' />
          </ConditionalRadioGroup.AlignedFieldsRadioGroup>
        </div>

        {{#if showConditionalBlock}}
          <div class='field'>
            <@form.Dropdown
              @labelName='Type de cancer non à petite cellule'
              @propertyName='nonSmallCellCancerType'
              as |dropdown|
            >
              {{#each this.nonSmallCellCancerTypes as |nonSmallCellCancerType|}}
                <dropdown.Item
                  @key={{nonSmallCellCancerType}}
                  @value={{t
                    (concat
                      'fur.cancer-medical-history.non-small-cell-cancer-type.'
                      nonSmallCellCancerType
                    )
                  }}
                />
              {{/each}}
            </@form.Dropdown>
          </div>
        {{/if}}
      </@form.ConditionalRadioGroup>
    </div>

    {{!     Mutation     }}

    <div class='field'>
      <@form.Dropdown
        @labelName='Mutation'
        @propertyName='mutation'
        @multipleSelection={{true}}
        as |dropdown|
      >
        {{#each this.mutations as |mutation|}}
          <dropdown.Item
            @key={{mutation}}
            @value={{t
              (concat 'fur.cancer-medical-history.mutations.' mutation)
            }}
          />
        {{/each}}
      </@form.Dropdown>
    </div>

    {{!     Statut PDL1     }}

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @propertyName='statutPDL1'
        @title='Statut PDL1 exprimé'
        as |Group|
      >
        <Group.FieldRadio @label='Oui' @value={{true}} />
        <Group.FieldRadio @label='Non' @value={{false}} />
      </@form.AlignedFieldsRadioGroup>
    </div>
  </template>
}
